var _path, _path2, _line;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUnvisitedSites(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.7214 14.5016C18.1164 16.092 18.7834 16.9392 18.3864 17.6216C18.3464 17.6898 18.2997 17.7557 18.2464 17.8192C17.6714 18.5016 16.1864 18.5016 13.2164 18.5016H7.78238C4.81238 18.5016 3.32838 18.5016 2.75338 17.8192C2.70092 17.756 2.65414 17.69 2.61338 17.6216C2.21638 16.94 2.88338 16.092 4.27838 14.5016M12.9994 8.10156C12.9994 8.632 12.736 9.1407 12.2671 9.51578C11.7983 9.89085 11.1624 10.1016 10.4994 10.1016C9.83634 10.1016 9.20046 9.89085 8.73161 9.51578C8.26277 9.1407 7.99938 8.632 7.99938 8.10156C7.99938 7.57113 8.26277 7.06242 8.73161 6.68735C9.20046 6.31228 9.83634 6.10156 10.4994 6.10156C11.1624 6.10156 11.7983 6.31228 12.2671 6.68735C12.736 7.06242 12.9994 7.57113 12.9994 8.10156Z",
    stroke: "#3D3D3D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.7555 14.8952C11.4178 15.1552 10.9672 15.3004 10.4985 15.3004C10.0298 15.3004 9.5793 15.1552 9.24153 14.8952C6.15253 12.5008 2.01353 9.8264 4.03153 5.9432C5.12453 3.8432 7.74453 2.5 10.4985 2.5C13.2525 2.5 15.8735 3.844 16.9655 5.9432C18.9815 9.8208 14.8525 12.5088 11.7555 14.8952Z",
    stroke: "#3D3D3D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 0.5,
    y1: 20.7929,
    x2: 20.7929,
    y2: 0.500001,
    stroke: "#3D3D3D",
    strokeLinecap: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnvisitedSites);
export default __webpack_public_path__ + "static/media/Unvisited Sites .0c4dbc48e1a144b5a2b11660fc03d734.svg";
export { ForwardRef as ReactComponent };